<div class="toolbar">
  <div class="toolbar-fields">
    <input
      type="text"
      class="toolbar-name"
      placeholder="Workflow name"
      [ngModel]="name()"
      (ngModelChange)="nameChange.emit($event)"
    />
    <input
      type="text"
      class="toolbar-description"
      placeholder="Description (optional)"
      [ngModel]="description()"
      (ngModelChange)="descriptionChange.emit($event)"
    />
  </div>

  <div class="toolbar-actions">
    <span class="toolbar-count">{{ nodeCount() }} node{{ nodeCount() === 1 ? '' : 's' }}</span>
    @if (nodeCount() > 0) {
      <span class="save-state" [class.unsaved]="hasUnsavedChanges()">
        @if (hasUnsavedChanges()) {
          <i class="pi pi-exclamation-circle"></i>
        }
        {{ hasUnsavedChanges() ? 'Unsaved changes' : 'Saved' }}
      </span>
    }
    <div class="orientation-switch" role="group" aria-label="Canvas orientation">
      <button
        type="button"
        class="orientation-option"
        [class.active]="orientation() === 'vertical'"
        [attr.aria-pressed]="orientation() === 'vertical'"
        title="Lay the workflow out top to bottom"
        (click)="orientationChange.emit('vertical')"
      >
        <i class="pi pi-arrow-down" aria-hidden="true"></i>
        <span class="sr-only">Vertical</span>
      </button>
      <button
        type="button"
        class="orientation-option"
        [class.active]="orientation() === 'horizontal'"
        [attr.aria-pressed]="orientation() === 'horizontal'"
        title="Lay the workflow out left to right"
        (click)="orientationChange.emit('horizontal')"
      >
        <i class="pi pi-arrow-right" aria-hidden="true"></i>
        <span class="sr-only">Horizontal</span>
      </button>
    </div>
    <button type="button" class="btn btn-secondary" (click)="createNew.emit()">New</button>
    <button type="button" class="btn btn-secondary" (click)="openExisting.emit()">Open</button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="saving() || !canSave()"
      [title]="!canSave() ? 'Fix validation errors before saving' : ''"
      (click)="save.emit()"
    >
      {{ saving() ? 'Saving…' : 'Save' }}
    </button>
  </div>
</div>
